import {Messages} from 'services/lang/messages';
import {system} from 'services/objects';

export let initialAdditionalData = {
  title: Messages.AdditionalText.D5,
  text: Messages.AdditionalText.EnterYourDetails,
  buttons: [
    {
      text: Messages.Controls.SingUp.toUpperCase(),
      key: system.LOGIN_PAGE_CONSTANTS.ID.SIGN_IN_BUTTON_ADDITIONAL,
      onClick: () => {},
    },
  ],
};

export let initialActiveData = {
  title: Messages.Controls.SingIn,
  buttons: [
    {
      key: system.LOGIN_PAGE_CONSTANTS.ID.SIGN_IN_BUTTON,
      text: Messages.Controls.SingIn.toUpperCase(),
      onClick: () => {},
    },
  ],
  links: [
    {
      text: '',
      href: '',
      key: system.LOGIN_PAGE_CONSTANTS.ID.FORGOT_PASSWORD,
      onClick: () => {},
    },
  ],
};
